import { Col, DatePicker, Divider, Form, Input, Row } from "antd";
import helper from "../../utils/helper";

interface Props {
    create: boolean,
    editAllInfo: boolean,
    validation: { englishRegex: RegExp },
    inputValidation9: boolean,
    onTaxIdChange: (value: string) => void,
    inputValidation10: boolean,
    onCrNumberChange: (value: string) => void,
    inputValidation11: boolean,
    onUnifiedNumberChange: (value: string) => void,
}

export default function RegistrationInformationSection(props: Props) {
    const {
        create,
        editAllInfo,
        validation,
        inputValidation9,
        onTaxIdChange,
        inputValidation10,
        onCrNumberChange,
        inputValidation11,
        onUnifiedNumberChange,
    } = props;

    return (
        <>
            <Divider orientation="left">Registration Information</Divider>
            <Row gutter={[12, 0]}>
                <Col span={8}>
                    <label htmlFor="">Tax Identification Number <span>*</span></label>
                    <Form.Item name="taxIdentificationNumber" validateFirst rules={[helper.notOnlySpacesRule, { required: create || editAllInfo, message: 'Required' }, ...(!inputValidation9 ? [] : [{ pattern: validation.englishRegex, message: 'Please input with English' }])]}>
                        <Input placeholder='Please enter tax identification number' disabled={!editAllInfo}
                            onChange={(e) => onTaxIdChange(e.target.value)}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <label htmlFor="">Commercial Register</label>
                    <Form.Item name="crNumber" validateFirst rules={[helper.notOnlySpacesRule, ...(!inputValidation10 ? [] : [{ pattern: validation.englishRegex, message: 'Please input with English' }])]}>
                        <Input placeholder='Please enter commercial register' disabled={!editAllInfo}
                            onChange={(e) => onCrNumberChange(e.target.value)}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <label htmlFor="">Unified Number <span>*</span></label>
                    <Form.Item name="unifiedNumber" validateFirst rules={[helper.notOnlySpacesRule, { required: create || editAllInfo, message: 'Required' }, ...(!inputValidation11 ? [] : [{ pattern: validation.englishRegex, message: 'Please input with English' }])]}>
                        <Input placeholder='Please enter unified number' disabled={!editAllInfo}
                            onChange={(e) => onUnifiedNumberChange(e.target.value)}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[12, 0]} style={{ marginBottom: '12px' }}>
                <Col span={8}>
                    <label htmlFor="">CR Issue Date <span>*</span></label>
                    <Form.Item name="crIssueDate" validateFirst rules={[helper.notOnlySpacesRule, { required: create || editAllInfo, message: 'Required' }]}>
                        <DatePicker placeholder="Enter CR issue date" style={{ width: "100%" }} disabled={!editAllInfo} />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <label htmlFor="">CR Issue Place </label>
                    <Form.Item name="crIssuePlace" validateFirst rules={[helper.notOnlySpacesRule]}>
                        <Input placeholder="Enter CR issue place" disabled={!editAllInfo} />
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}
